export default function UnderConstruction() {
    return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
        <h2>Under Construction</h2>
        <p>Sorry, this page is currently under construction. Please check back later.</p>
        <img
            src="https://i.giphy.com/xZsLh7B3KMMyUptD9D.webp"
            alt="Under Construction GIF"
            style={{ width: '300px', height: '300px', margin: '20px' }}
        />
    </div>;
}